<template>
  <div class="container">
    <div v-if="!isAuthLv1" class="row justify-content-center">
      <div class="col-md-12 mt-5 text-center">
        <h3>Unauthorized</h3>
        <p>You do not have permission to view this page.</p>
      </div>
    </div>
    <div v-else class="row justify-content-center">
      <div class="col-md-12 mt-3">
        <product-package v-if="getSaleProductState == 0"></product-package>
        <product-payment v-if="getSaleProductState == 1"></product-payment>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { isAuthLv1 } from "./../js/utils/global.js";
import ProductPackage from "./ProductPackage.vue";
import ProductPayment from "./ProductPayment.vue";

export default {
  data() {
    return {
      currentStep: 0,
    };
  },
  components: {
    ProductPackage,
    ProductPayment,
  },
  computed: {
    isAuthLv1() {
      return isAuthLv1();
    },
    ...mapGetters(["getSaleProductState"]),
  },
  mounted() {
    //console.log("here");
    this.$store.dispatch("setSaleProductState", 0);
  },
  methods: {
    //...mapMutations([]),
    ...mapActions(["incrementCounter"]),
  },
};
</script>
